var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "table table-bordered", staticStyle: { width: "100%" } },
    [
      _c("thead", [
        _c("tr", [
          _c("th", { staticStyle: { "min-width": "130px" } }, [
            _vm._v(_vm._s(_vm.$t("message.date")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.cashier")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("apps.pos.message.possession")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.transactions")))
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.product")))
          ]),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.cost
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.cost")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.discount
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.discount")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.tax
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.tax")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.collect
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.collect")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.refund
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.refund")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.net
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.net")) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getRoleMetadata.view.fields.profit
            ? _c("th", { staticClass: "text-right" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.profit")) + "\n      "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.items, function(item, index) {
            return _c("tr", { key: index }, [
              _c("td", [_vm._v("\n        " + _vm._s(item.date) + "\n      ")]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getNumber(item.cashiersCount)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getNumber(item.sessionsCount)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getNumber(item.transactionsCount)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getNumber(item.productsCount)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.cost
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.cost)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.discount
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.discount)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.tax
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.tax)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.collect
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.collect)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.refund
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.refund)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.net
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.net)) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getRoleMetadata.view.fields.profit
                ? _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumber(item.profit)) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("apps.reports.message.total")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getNumber(_vm.summary.sessionsCount)) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getNumber(_vm.summary.cashiersCount)) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getNumber(_vm.summary.transactionsCount)) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getNumber(_vm.summary.productsCount)) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.cost
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.cost)) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.discount
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.discount)) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.tax
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.tax)) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.collect
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.collect)) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.refund
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.refund)) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.net
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.net)) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getRoleMetadata.view.fields.profit
              ? _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getNumber(_vm.summary.profit)) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145e4eba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145e4eba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/ReportSaleTable.vue
// module id = null
// module chunks = 